import { Component, Fragment, useState } from "react";
import * as React from 'react';
import { Form, Accordion, Card} from 'react-bootstrap';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import CheckBoxChecked from '../../images/check_box_checked.svg';
import CheckBoxUnCheck from '../../images/check_box_uncheck.svg';

import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop  from '../../images/chevron-top.svg';
import InfoChecked from '../../images/info_icon/checked.svg';

function CustomToggle({ init, children, eventKey }) {
    const decoratedOnClick = useAccordionToggle(eventKey);
    const [toggle, setToggle] = useState(false);

    const onToggle = (e) => {
        if(e.stopPropagation) {
            e.stopPropagation();
        }
        setToggle(!toggle);
        decoratedOnClick();
    }
  
    const forceAction = (toggleValue) => {
        if(!toggle) {
            setToggle(toggleValue);
            decoratedOnClick();
        }
    }

    if(init) {
        init(forceAction);
    }

    return (
      <div className="accordion-toggle" 
        name="toggle"
        onClick={(e) => onToggle(e)}
      >
        {children}
        <img src={toggle ? SpanMoreTabTop: SpanMoreTabDown}
          width="16px"
          height="16px"
          alt="span image"
        />
      </div>
    );
}


const InfoItemDetail = (props) => {
    return  (
            <div className="d-flex item-detail">
                <img src={InfoChecked} width="24px" height="24px" />
                <p className="text-educate">{props.children}</p>
            </div>
        )
}
  
export default class CheckBoxInsurance extends Component {

    state = {
        isToggle: false,
        checked: false,
        checked2: false,
        checked3: false
    }
    callBackAction;

    constructor(props) {
        super(props);
        this.state.checked = props.checked;
        this.state.checked2 = props.checked2;
        this.state.checked3 = props.checked3;
    } 
    
      _onCheckSecond = () => {
        const { checked2 } = this.state;
        const { onCheckSecond } = this.props;
        const next = !checked2;
    
        this.setState({ ...this.state, checked2: next }, res => {
          if (onCheckSecond) {
            onCheckSecond(next);
          }
        });
      };
    
      _onCheckThird = () => {
        const { checked3 } = this.state;
        const { onCheckThird } = this.props;
        const next = !checked3;
    
        this.setState({ ...this.state, checked3: next }, res => {
          if (onCheckThird) {
            onCheckThird(next);
          }
        });
      };

    _onCheckChange = (name) => {
        const { checked, checked3 } = this.state;
        const { onCheckChange } = this.props;

        
        let next = !checked;
        if (name == 'acceptInsurance') {
            this.setState({ ...this.state, checked: next});
        } else if (name == 'acceptHealthCheck') {
            next = !checked3;
            this.setState({ ...this.state, checked3: next});
        }
        if(next) {
            this.callBackAction = true;
        }
        if(onCheckChange) {
            onCheckChange(name, next);
        }
    }
    _onCollasped = (isToggle) => {
        this.setState({ ...this.state, isToggle: isToggle});
    }

    _onToggleInit = callBackAction => {
        if(callBackAction) {
            this.callBackAction = callBackAction;
        }
    }

    render() {
        const { checked, checked2, checked3 } = this.state;
        const imgSource = checked ? CheckBoxChecked : CheckBoxUnCheck;
        const imgSource2 = checked2 ? CheckBoxChecked : CheckBoxUnCheck;
        const imgSource3 = checked3 ? CheckBoxChecked : CheckBoxUnCheck;

        return (
            <Fragment>
                <Accordion className="checkbox-wrapper">
                    <Form.Group className="d-flex-row">
                        <div className="d-flex" onClick={() => this._onCheckChange('acceptInsurance')}>
                            <img src={imgSource} className="mr-2" width="24px" height="24px" />
                            <p className="d-flex-row text-educate-red mr-2 mb-0">*</p>
                            <p className="d-flex-row mb-0">ข้าพเจ้าตกลงทำประกันภัย</p> 
                            <CustomToggle eventKey="1" init={this._onToggleInit}>
                                <p>ตามเงื่อนไข</p>
                            </CustomToggle>
                        </div>
                    </Form.Group>
                    <Accordion.Collapse eventKey="1">
                        <Fragment>
                            <Card.Body className="accordion-collapse">
                                <p className="text-educate">
                                - ข้าพเจ้าขอรับรองว่า ข้าพเจ้ามีสุขภาพแข็งแรง ไม่มีส่วนใดส่วนหนึ่งพิการหรือทุพพลภาพ และไม่มีโรคประจำตัวเรื้อรัง โรคร้ายแรง 
                                ไม่เป็นผู้วิกลจริต ไม่มีอาการหรือโรคที่เกี่ยวเนื่องกับภาวะทางจิต โรคพิษสุราเรื้อรัง และไม่เป็นผู้ติดสารเสพติด และขอรับรองว่า 
                                คำแถลงตามรายการข้างบนเป็นความจริง และให้ถือเป็นส่วนหนึ่งของสัญญาประกันภัยระหว่างข้าพเจ้าและบริษัท เมืองไทยประกันภัย จำกัด (มหาชน)
                                </p>
                                <p className="text-educate">
                                - ข้าพเจ้ารับทราบข้อกำหนดและเงื่อนไขการรับประกันภัยตามแผนความคุ้มครองที่ข้าพเจ้าได้เลือกไว้ และตกลงขอเอาประกันภัยภายใต้ข้อกำหนด 
                                และเงื่อนไขการประกันภัยดังกล่าว
                                </p>
                                <p className="text-educate">
                                - ข้าพเจ้ายินยอมให้บริษัทฯ จัดเก็บใช้ และเปิดเผย ข้อเท็จจริงเกี่ยวกับสุขภาพและข้อมูลของข้าพเจ้าต่อสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย 
                                เพื่อประโยชน์ในการกำกับดูแลธุรกิจประกันภัย
                                </p>
                                <p className="text-educate">
                                - ข้าพเจ้าขอรับรองว่าข้อมูลที่แจ้งให้ทราบเป็นความจริงทุกประการ และตกลงทำประกันภัยตามทุนประกันภัย ดังกล่าวข้างต้น และ "ข้าพเจ้าขอรับรองและยืนยันว่า 
                                ข้าพเจ้าไม่เคยมีประวัติการกระทำผิดกฎหมายป้องกันและปราบปรามการฟอกเงิน หรือ กฎหมายป้องกันและปราบปรามการสนับสนุนทางการเงินแก่การก่อการร้าย
                                และการแพร่ขยายอาวุธที่มีอานุภาพทำลายล้างสูง หรือกฎหมายอื่นที่เกี่ยวข้อง เช่น กฎหมายเกี่ยวกับยาเสพติดให้โทษ และข้าพเจ้าขอรับรองว่าข้อมูลรายละเอียดข้างต้นเป็นความจริงทุกประการ
                                </p>
                                <p className="text-educate-red mb-4"><u>คำเตือน</u> ของสำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.) 
                                ให้ตอบคำถามข้างต้นตามความเป็นจริงทุกข้อ หากผู้ขอเอาประกันภัยปกปิดข้อความจริง หรือแถลงข้อความอันเป็นเท็จจะมีผลให้สัญญานี้ตกเป็นโมฆะ 
                                ซึ่งบริษัทมีสิทธิบอกล้างสัญญาประกันภัยได้ ตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865</p>
                            </Card.Body>
                        </Fragment>
                    </Accordion.Collapse>
                </Accordion>
                <Accordion className="checkbox-wrapper">
                    <Form.Group className="d-flex">
                        <div className="d-flex" onClick={this._onCheckSecond}>
                            <img src={imgSource2} className="mr-2" width="24px" height="24px" />
                            <p className="mb-0">ข้าพเจ้ายินยอมให้บริษัทใช้หมายเลขโทรศัพท์ หมายเลขโทรศัพท์มือถือ และ/หรืออีเมล์ ที่ให้ไว้ข้างต้นนี้ ในการแจ้งผลที่ข้าพเจ้าได้รับการอนุมัติหรือข่าวสารอื่นๆ การเสนอขายผลิตภัณฑ์ของบริษัท และข้าพเจ้าจะแจ้งให้บริษัททราบทันทีหากมีการเปลี่ยนแปลงใดๆ</p>
                        </div>
                    </Form.Group>
                </Accordion>
                <Accordion className="checkbox-wrapper">
                    <Form.Group className="d-flex-row">
                        <div className="d-flex" onClick={() => this._onCheckChange('acceptHealthCheck')}>
                            <img src={imgSource3} className="mr-2" width="24px" height="24px" />
                            <p className="d-flex-row text-educate-red mr-2">*</p>
                            <p className="d-flex-row mb-0">ข้าพเจ้ายินยอมให้บริษัทฯ เก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลเกี่ยวกับสุขภาพและ/หรือข้อมูลใดๆ ของข้าพเจ้าเท่าที่จำเป็นสำหรับการประกันภัยนี้ และข้าพเจ้ายินยอมให้บริษัทฯ ตรวจสอบประวัติการรักษาพยาบาลและการตรวจวินิจฉัยของข้าพเจ้า และมีสิทธิทำการชันสูตรพลิกศพในกรณีที่มีเหตุจำเป็นและไม่เป็นการขัดต่อกฎหมาย เพื่อประกอบการพิจารณาจ่ายผลประโยชน์ตามกรมธรรม์ประกันภัย ทั้งนี้ ในกรณีที่ไม่ให้ความยินยอมแก่บริษัทฯ ในการตรวจสอบประวัติการรักษาพยาบาลและการตรวจวินิจฉัย และชันสูตรพลิกศพ บริษัทฯ สามารถปฏิเสธการจ่ายผลประโยชน์ตามกรมธรรม์ประกันภัยได้</p>
                        </div>
                        <div className="d-flex">
                            <p className="d-flex-row text-educate-red" style={{marginLeft: "30px"}}>*</p>
                            <p className="d-flex-row ml-2 mb-0">กรุณาให้ความยินยอมในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลเกี่ยวกับสุขภาพ</p>
                        </div>
                        <div style={{marginLeft: "30px"}}>
                        <p className="mb-0">ข้าพเจ้ายินดีรับข้อมูลข่าวสาร การสื่อสาร สิทธิประโยชน์ โปรโมชั่นพิเศษ และกิจกรรมต่างๆ ของบริษัทฯ ที่จัดขึ้นสำหรับลูกค้าของเมืองไทยประกันภัย และยินยอมให้บริษัทฯ เก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าเพื่อการดำเนินการดังกล่าวได้</p>
                        </div>
                    </Form.Group>
                </Accordion>
            </Fragment>
        )
    }
}
